import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingCenteredImageLarge: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 2.5h12V0H2zM2 16h12v-2.5H2zM16 4.5H0v7h16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingCenteredImageLarge
